import { FormInput, FormSelect, TriStateSelectOptions, spreadAndtransformDefaultValues } from '@common/components/forms';
import { HospitalModel, macroTypes } from "@common/models";
import { MacroType } from "@common/models/Enums/MacroType";
import { ICommunicationTemplateFilter } from "@common/stores/CommunicationTemplateSearchStore";
import { find } from "lodash";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

export interface ICommunicationTemplatesFilterProps {
    searchFilter: ICommunicationTemplateFilter,
    defaultFilter: ICommunicationTemplateFilter,
    onClearFilter: () => void;
    onUpdateFilter: (data: ICommunicationTemplateFilter) => void;
    fetchHospitals?: () => void
    hospitals?: Array<HospitalModel>
    macroScope?: MacroType
}

export const CommunicationTemplatesFilter = observer(({ onClearFilter, defaultFilter, searchFilter, onUpdateFilter, fetchHospitals, hospitals, macroScope }: ICommunicationTemplatesFilterProps) => {
    const { handleSubmit, control, reset, resetField, watch } = useForm<ICommunicationTemplateFilter>({ defaultValues: spreadAndtransformDefaultValues(searchFilter) });

    useEffect(() => {
        fetchHospitals && fetchHospitals();
    }, [fetchHospitals])

    /**
     * Clear all existing filters and resets form
     */
    const removeAllFilters = () => {
        onClearFilter()
        reset(spreadAndtransformDefaultValues(defaultFilter))
    }

    const macroType = watch("macroTypeId");

    return (
        <Form onSubmit={handleSubmit(onUpdateFilter)}>
            <div className="mb-3">
                <FormInput label="Created By" fieldName="createdBy" control={control} placeholder="Type user name" />
            </div>
            <div className="mb-3">
                <FormInput label="Last Modified By" fieldName="lastModifiedBy" control={control} placeholder="Type user name" />
            </div>
            <div className="mb-3">
                <FormSelect label="Type" fieldName="macroTypeId" control={control}
                    isRequired={false}
                    options={macroTypes}
                    getOptionLabel={opt => opt.label}
                    getOptionValue={opt => opt.value.toString()}
                    mapValueToOption={value => find(macroTypes, { value })}
                    mapOptionToValue={opt => opt?.value}
                    onOptionChanged={(option) => {
                        if (option?.value == MacroType.Location) resetField('userName');
                        if (option?.value == MacroType.Provider) resetField('hospitalId');
                    }}
                />
            </div>
            <div className="mb-3">
                <FormSelect label="Assigned to (Location)" fieldName="hospitalId" control={control}
                    isRequired={false}
                    isDisabled={macroScope == MacroType.Provider || macroType == MacroType.Provider || macroScope == MacroType.Location}
                    options={hospitals}
                    getOptionLabel={s => s.name}
                    getOptionValue={s => s.hospitalId.toString()}
                    mapOptionToValue={opt => opt?.hospitalId}
                    mapValueToOption={hospitalId => find(hospitals, { hospitalId: hospitalId ?? 0 })}
                />
            </div>
            <div className="mb-3">
                <FormInput label="Assigned to (Users Vets)" fieldName="userName" control={control} disabled={macroType == MacroType.Location} placeholder="Type user name" />
            </div>

            <div className="mb-3">
                <FormInput label="Name" fieldName="name" control={control} placeholder="Type template name" />
            </div>
            <div className="mb-3">
                <FormSelect label="Status" fieldName="isActive" control={control}
                    isRequired={false}
                    options={TriStateSelectOptions}
                    getOptionLabel={opt => opt.name}
                    getOptionValue={opt => opt.value === null ? '' : opt.value.toString()}
                    mapValueToOption={val => TriStateSelectOptions.filter(p => val === undefined ? p.value === null : p.value === val)[0]}
                    mapOptionToValue={opt => opt?.value === null ? undefined : opt?.value as boolean}
                />
            </div>
            <Form.Group>
                <Button className="sideBarButton" variant="primary" type="submit">
                    Filter
                </Button>
                <Button className="sideBarButton" variant="outline-primary" onClick={removeAllFilters}>
                    Remove All Filters
                </Button>
            </Form.Group>
        </Form>
    )
});
